// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33y8F","inner":"Footer_inner__28jd4","nextIcon":"Footer_nextIcon__KMUmO","innerLeft":"Footer_innerLeft__2uhoB"};